import React from 'react';
import classNames from 'classnames';
import DeviceHealthStatus from '../../models/deviceHealthStatus';
import BatteryIcon from '../device/BatteryIcon';
import MaterialIcon from '../MaterialIcon';
import styles from './BatteryComponent.module.scss';

type Props = {
    batteryPercentage: number | undefined;
    healthStatus: DeviceHealthStatus;
    connectivityStatus?: number;
};

const BatteryComponent = ({ batteryPercentage, healthStatus, connectivityStatus }: Props): React.ReactElement => {
    const deviceOffline: boolean = healthStatus === DeviceHealthStatus.offline;

    const isUsbPowered = batteryPercentage === -1 || (batteryPercentage === undefined && connectivityStatus === 2);
    if (isUsbPowered) {
        return (
            <div
                className={classNames(styles.body, {
                    [styles.batteryGreyed]: deviceOffline,
                })}
            >
                <div className={styles.battery}>
                    <MaterialIcon name="usb" />
                </div>
            </div>
        );
    }

    const hasBatteryData: boolean = !!batteryPercentage && batteryPercentage >= 0;
    if (hasBatteryData) {
        return (
            <div
                className={classNames(styles.body, {
                    [styles.batteryGreyed]: deviceOffline,
                })}
            >
                <div className={styles.battery}>
                    <BatteryIcon batteryPercentage={batteryPercentage} isHubConnectionLost={deviceOffline} />
                </div>
            </div>
        );
    }
    return <div />;
};

export default BatteryComponent;
